import {action} from 'utils/redux';
import namespace from './namespace';
import {P, Nullable} from 'utils/types';

const creator = action(namespace);

export const initialize = creator('initialize');

export const destroy = creator('destroy');

export const setNotFound = creator('setNotFound');

export const searchBuildings = creator('searchBuildings');

export const navigateToBuilding = creator('navigateToBuilding', P.Object);

export const openCondoCreator = creator('openCondoCreator', Nullable(P.Object));

export const closeCondoCreator = creator('closeCondoCreator');

export const saveCondo = creator('saveCondo', P.Object);

export const _initialize = creator('_initialize');

export const _setBuildings = creator('_setBuildings', P.Array);

export const _saveCondo = creator('_saveCondo');

export const _opOk = creator('_opOk');

export const _opFailed = creator('_opFailed');
